import React from "react";
import styles from "./WelcomeStep.module.scss";
import { observer } from "mobx-react";
import { useStores } from "../../../../hooks/mobx";

const WelcomeStep = observer(() => {
  const { helpMeStore } = useStores();
  const { closeWelcomePage } = helpMeStore;
  return (
    <div className={styles.Wrapper}>
      <div className={styles.WelcomeStep}>
        <div className={styles.WelcomeStep_Content}>
          <div className={styles.WelcomeStep_Content_Texts}>
            <div className={styles.WelcomeStep_Content_Texts_MainInfo}>
              <h1 className={styles.WelcomeStep_Content_Texts_MainInfo_Title}>
                Поиск доноров
              </h1>
            </div>
            <div className={styles.WelcomeStep_Content_Texts_AdditionInfo}>
              <div
                className={
                  styles.WelcomeStep_Content_Texts_AdditionInfo_SubTitle
                }
              >
                Прежде чем создать заявку на поиск, пожалуйста, прочитайте нашу
                памятку и проверьте, насколько публичный поиск доноров необходим
                в вашем случае.
              </div>
              <div
                className={styles.WelcomeStep_Content_Texts_AdditionInfo_List}
              >
                <h4
                  className={
                    styles.WelcomeStep_Content_Texts_AdditionInfo_List_Header
                  }
                >
                  Когда поиск доноров оправдан?
                </h4>
                <div
                  className={
                    styles.WelcomeStep_Content_Texts_AdditionInfo_List_List
                  }
                >
                  <div
                    className={
                      styles.WelcomeStep_Content_Texts_AdditionInfo_List_Item
                    }
                  >
                    <img
                      src="/static/images/eventIcons/Check.svg"
                      alt="Check"
                    />
                    <div>
                      <strong>
                        Нужны компоненты с ограниченным сроком хранения.
                      </strong>{" "}
                      Например, тромбоциты или гранулоциты.
                    </div>
                  </div>
                  <div
                    className={
                      styles.WelcomeStep_Content_Texts_AdditionInfo_List_Item
                    }
                  >
                    <img
                      src="/static/images/eventIcons/Check.svg"
                      alt="Check"
                    />
                    <div>
                      <strong>
                        Лечащий врач пациента выдал вам направление на поиск
                        доноров,
                      </strong>{" "}
                      где указаны актуальные даты поиска, необходимое количество
                      доноров, тип донации, группа крови, резус-фактор и центр
                      крови, где нужно сдавать кровь.
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={styles.WelcomeStep_Content_Texts_AdditionInfo_List}
              >
                <h4
                  className={
                    styles.WelcomeStep_Content_Texts_AdditionInfo_List_Header
                  }
                >
                  Как работает донорство?
                </h4>
                <div
                  className={
                    styles.WelcomeStep_Content_Texts_AdditionInfo_List_List
                  }
                >
                  <div
                    className={
                      styles.WelcomeStep_Content_Texts_AdditionInfo_List_Item
                    }
                  >
                    <img
                      src="/static/images/eventIcons/Check.svg"
                      alt="Check"
                    />
                    <div>
                      В большинстве* случаев донорскую кровь{" "}
                      <strong>напрямую не переливают</strong> — после сдачи её
                      делят на компоненты: тромбоциты, плазму и эритроциты.
                      Пациент получает именно тот компонент, который ему
                      необходим.
                      <br />
                      <i>
                        *Исключение составляют тромбоциты и гранулоциты, так как
                        имеют очень небольшой срок хранения и их не
                        заготавливают впрок.
                      </i>
                    </div>
                  </div>
                  <div
                    className={
                      styles.WelcomeStep_Content_Texts_AdditionInfo_List_Item
                    }
                  >
                    <img
                      src="/static/images/eventIcons/Check.svg"
                      alt="Check"
                    />
                    <div>
                      В больницах всегда есть неснижаемый запас донорских
                      компонентов — так называемый <strong>банк крови.</strong>{" "}
                      Очень часто, когда речь идёт о поиске донора для
                      конкретного пациента, кровь идёт на пополнение запасов
                      банка взамен той, что была/будет использована.
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  styles.WelcomeStep_Content_Texts_AdditionInfo_LastTitle
                }
              >
                Врачи <strong>обязаны провести переливание крови</strong> по
                жизненным показаниям вне зависимости от того, были найдены
                доноры на замену или нет.
              </div>
            </div>
          </div>
        </div>
        <div className={styles.WelcomeStep_Button}>
          <button onClick={closeWelcomePage}>Создать заявку</button>
        </div>
      </div>
    </div>
  );
});

export default WelcomeStep;
